import { AnalyticsStore } from 'bernie-plugin-mobx';
import { codeSplit, Controller, FetchOptions, Result } from 'bernie-core';
import '../client/temp-common-imports';

// Data
import { pageNames } from 'data/page-names';
import { UiStore } from 'stores';

// util
import analyticsUtil from '../util/analytics-util';

export class AboutYourApplicationController implements Controller {
  public pageId = pageNames.aboutYourApplication;
  public path = '/:locale/about-your-application';
  public routeName = 'about-your-application';
  public exact = true;
  public bundles = [];

  public component = codeSplit(
    () => import(/* webpackChunkName: "about-your-application" */ '../views/about-your-application-page'),
  );

  public fetch(options: FetchOptions) {
    const { stores, request } = options;
    const analyticsStore: AnalyticsStore = stores && stores.get<AnalyticsStore>('analytics');

    const uiStore = stores?.get<UiStore>('uiStore');
    uiStore?.setPageName(this.pageId);

    analyticsUtil.runAnalytics(this.pageId, analyticsStore, request.context);

    return Promise.resolve({});
  }

  public fetchPageData() {
    return Promise.resolve({ title: 'About your application' });
  }
}
